import React, { useState } from "react";
import SinglePie from "./Graphs/SinglePie";

export default function DispEffect({ dispEffectPerc }) {
  const [showInfo, setShowInfo] = useState(false);

  const handleClick = () => {
    setShowInfo((prevShowInfo) => !prevShowInfo);
  };
  return (
    <>
      <section className="bias-container">
        <div className="bias-text">
          <h2 className="bias-header"> Disposition Effect</h2>
          <h3 className="bias-subheader">
            a measure of how impartial you are in realizing a profit or loss
          </h3>
          <button className="btn bias-button link-wrapper-btn">
            <a
              className="link-no-style btn-link"
              href="https://en.wikipedia.org/wiki/Disposition_effect"
              target="_blank"
              rel="noreferrer"
            >
              Learn more
            </a>
          </button>
        </div>
        <figure className="bias-graph">
          <SinglePie effectPerc={dispEffectPerc} />
          <div
            className="bias-add-info-container"
            onClick={handleClick}
            onMouseEnter={() => {
              if (!("ontouchstart" in document.documentElement)) {
                setShowInfo(true);
              }
            }}
            onMouseLeave={() => setShowInfo(false)}
          >
            <div>?</div>
            {showInfo && (
              <div className="bias-add-info">
                <span>Top Score: 0%</span>
                <span>Bottom Score: 100%</span>
              </div>
            )}
          </div>
        </figure>
      </section>
    </>
  );
}
